export default {
    maxSavedSession : 10
}